// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionPayload, unionToActionPayload, unionListToActionPayload } from '../tbs/action-payload.js';
import { AddPlayerAction, AddPlayerActionT } from '../tbs/add-player-action.js';
import { CancelFactoryOrderAction, CancelFactoryOrderActionT } from '../tbs/cancel-factory-order-action.js';
import { ClaimPlayerSlotAction, ClaimPlayerSlotActionT } from '../tbs/claim-player-slot-action.js';
import { DeleteLobbyAction, DeleteLobbyActionT } from '../tbs/delete-lobby-action.js';
import { DeleteMapAction, DeleteMapActionT } from '../tbs/delete-map-action.js';
import { DeletePlayerAction, DeletePlayerActionT } from '../tbs/delete-player-action.js';
import { EndGameAction, EndGameActionT } from '../tbs/end-game-action.js';
import { EndRoundAction, EndRoundActionT } from '../tbs/end-round-action.js';
import { EndTurnAction, EndTurnActionT } from '../tbs/end-turn-action.js';
import { EraseTileAction, EraseTileActionT } from '../tbs/erase-tile-action.js';
import { KickPlayerSlotAction, KickPlayerSlotActionT } from '../tbs/kick-player-slot-action.js';
import { LeavePlayerSlotAction, LeavePlayerSlotActionT } from '../tbs/leave-player-slot-action.js';
import { MapToLobbyAction, MapToLobbyActionT } from '../tbs/map-to-lobby-action.js';
import { MoveUnitAction, MoveUnitActionT } from '../tbs/move-unit-action.js';
import { PaintTileAction, PaintTileActionT } from '../tbs/paint-tile-action.js';
import { PatchConfigAction, PatchConfigActionT } from '../tbs/patch-config-action.js';
import { PatchMapAction, PatchMapActionT } from '../tbs/patch-map-action.js';
import { PatchPlayerAction, PatchPlayerActionT } from '../tbs/patch-player-action.js';
import { PlaceFactoryOrderAction, PlaceFactoryOrderActionT } from '../tbs/place-factory-order-action.js';
import { PublishMapAction, PublishMapActionT } from '../tbs/publish-map-action.js';
import { ReservePlayerSlotAction, ReservePlayerSlotActionT } from '../tbs/reserve-player-slot-action.js';
import { RestoreLobbyAction, RestoreLobbyActionT } from '../tbs/restore-lobby-action.js';
import { RestoreMapAction, RestoreMapActionT } from '../tbs/restore-map-action.js';
import { RotateEntityAction, RotateEntityActionT } from '../tbs/rotate-entity-action.js';
import { RownipulatorAddRowAction, RownipulatorAddRowActionT } from '../tbs/rownipulator-add-row-action.js';
import { RownipulatorDeleteRowAction, RownipulatorDeleteRowActionT } from '../tbs/rownipulator-delete-row-action.js';
import { RownipulatorDuplicateRowAction, RownipulatorDuplicateRowActionT } from '../tbs/rownipulator-duplicate-row-action.js';
import { SetBotPlayerSlotAction, SetBotPlayerSlotActionT } from '../tbs/set-bot-player-slot-action.js';
import { SetEntityElevationAction, SetEntityElevationActionT } from '../tbs/set-entity-elevation-action.js';
import { SetEntsAction, SetEntsActionT } from '../tbs/set-ents-action.js';
import { SetStateAction, SetStateActionT } from '../tbs/set-state-action.js';
import { StartNewGameAction, StartNewGameActionT } from '../tbs/start-new-game-action.js';
import { StartRoundAction, StartRoundActionT } from '../tbs/start-round-action.js';
import { StartTurnAction, StartTurnActionT } from '../tbs/start-turn-action.js';
import { UnpublishMapAction, UnpublishMapActionT } from '../tbs/unpublish-map-action.js';


export class ActionEnvelope implements flatbuffers.IUnpackableObject<ActionEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ActionEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsActionEnvelope(bb:flatbuffers.ByteBuffer, obj?:ActionEnvelope):ActionEnvelope {
  return (obj || new ActionEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsActionEnvelope(bb:flatbuffers.ByteBuffer, obj?:ActionEnvelope):ActionEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ActionEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

actionType():ActionPayload {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActionPayload.NONE;
}

action<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startActionEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addActionType(builder:flatbuffers.Builder, actionType:ActionPayload) {
  builder.addFieldInt8(0, actionType, ActionPayload.NONE);
}

static addAction(builder:flatbuffers.Builder, actionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, actionOffset, 0);
}

static endActionEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createActionEnvelope(builder:flatbuffers.Builder, actionType:ActionPayload, actionOffset:flatbuffers.Offset):flatbuffers.Offset {
  ActionEnvelope.startActionEnvelope(builder);
  ActionEnvelope.addActionType(builder, actionType);
  ActionEnvelope.addAction(builder, actionOffset);
  return ActionEnvelope.endActionEnvelope(builder);
}

unpack(): ActionEnvelopeT {
  return new ActionEnvelopeT(
    this.actionType(),
    (() => {
      const temp = unionToActionPayload(this.actionType(), this.action.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ActionEnvelopeT): void {
  _o.actionType = this.actionType();
  _o.action = (() => {
      const temp = unionToActionPayload(this.actionType(), this.action.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class ActionEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public actionType: ActionPayload = ActionPayload.NONE,
  public action: AddPlayerActionT|CancelFactoryOrderActionT|ClaimPlayerSlotActionT|DeleteLobbyActionT|DeleteMapActionT|DeletePlayerActionT|EndGameActionT|EndRoundActionT|EndTurnActionT|EraseTileActionT|KickPlayerSlotActionT|LeavePlayerSlotActionT|MapToLobbyActionT|MoveUnitActionT|PaintTileActionT|PatchConfigActionT|PatchMapActionT|PatchPlayerActionT|PlaceFactoryOrderActionT|PublishMapActionT|ReservePlayerSlotActionT|RestoreLobbyActionT|RestoreMapActionT|RotateEntityActionT|RownipulatorAddRowActionT|RownipulatorDeleteRowActionT|RownipulatorDuplicateRowActionT|SetBotPlayerSlotActionT|SetEntityElevationActionT|SetEntsActionT|SetStateActionT|StartNewGameActionT|StartRoundActionT|StartTurnActionT|UnpublishMapActionT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const action = builder.createObjectOffset(this.action);

  return ActionEnvelope.createActionEnvelope(builder,
    this.actionType,
    action
  );
}
}
